/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PostUploadLogoMutationRequest, PostUploadLogoMutationResponse, PostUploadLogoQueryParams, PostUploadLogo400 } from "../../models/PostUploadLogo";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPostUploadLogoUrl() {
  const res = { method: 'POST', url: `/api/v1/logos` as const }  
  return res
}

/**
 * {@link /api/v1/logos}
 */
export async function postUploadLogo({ data, params }: { data: PostUploadLogoMutationRequest; params?: PostUploadLogoQueryParams }, config: Partial<RequestConfig<PostUploadLogoMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  const formData = new FormData()
  if (requestData) {
   Object.keys(requestData).forEach((key) => {
     const value = requestData[key as keyof typeof requestData];
     if (typeof value === 'string' || (value as unknown) instanceof Blob) {
       formData.append(key, value as unknown as string | Blob);
     } else {
       formData.append(key, JSON.stringify(value));
     }
   })
  }  
  const res = await request<PostUploadLogoMutationResponse, ResponseErrorConfig<PostUploadLogo400>, PostUploadLogoMutationRequest>({ method : "POST", url : getPostUploadLogoUrl().url.toString(), params, data : formData, ... requestConfig })  
  return res.data
}